import {
    IqCssClassnames,
    addContainerClassesNoRules,
    multiClasses,
} from '@dat/iq-style-processor';
import { Component as ComponentType } from '../../models';
import { idCreator } from '../../models/builder-utils';
import { matInputHideSubscript } from '@dat/iq-style-processor';

export const CenteredSectionClasses = multiClasses(
    ['!bg-transparent', 'max-w-[1140px]', 'mx-auto'],
    ['[data-uitype="builder-section"]'],
);

export function createSectionClasses(
    colSpan: number,
    hasBorder: boolean,
): IqCssClassnames {
    const borderClasses = hasBorder
        ? [
              'border-solid',
              'border-dat-grey-100',
              'border-t-0',
              'border-b-[1px]',
              'border-l-0',
              'border-r-0',
          ]
        : [];
    return {
        ...CenteredSectionClasses,
        ...addContainerClassesNoRules([`col-span-${colSpan}`]),
        ...multiClasses(
            ['py-[100px]', 'sm:pb-[50px]', ...borderClasses],
            ['[data-uitype="builder-section"]'],
        ),
    };
}

export const TwoColumnDashboard = addContainerClassesNoRules([
    'w-full',
    'h-full',
    'mt-[50px]',
    'text-white',
    'grid',
    'grid-cols-2',
    'sm:overflow-x-hidden',
    'tablet:overflow-x-hidden',
]);

export function createdHeader(label: string): string {
    return `<h2 class="tl-section-header text-white m-0 mb-10 sm:px-[25px] tablet:mb-[10px]">${label}</h2>`;
}

export const createdHeaderComponent: (
    idRoot: string,
    equipmentType: EquipTypes,
    label: string,
) => ComponentType = (
    idRoot: string,
    equipmentType: EquipTypes,
    label: string,
): ComponentType => ({
    id: idCreator(idRoot, [equipmentType, 'header']),
    type: 'Label',
    props: {
        label: `<h1 class="tl-section-header text-white m-0 mb-10 sm:px-[25px] tablet:px-[25px]">${label}</h1>`,
    },
});

export type EquipTypes = 'VAN' | 'REEFER' | 'FLATBED';

export const Controls: (
    idRoot: string,
    currentValue: string,
) => ComponentType = (idRoot: string, currentValue: string): ComponentType => ({
    id: `trendlines-page-selector`,
    type: 'Controls',
    classNames: {
        ...addContainerClassesNoRules([
            'w-full',
            'flex',
            'justify-end',
            'sm:justify-center',
        ]),
    },
    onChange: [
        {
            name: 'iframePostMessage',
            payload: {
                type: 'IFRAME_NAVIGATE_URL',
                payload: {
                    url: `<%= form.currentUrl.data %>`,
                },
            },
            sourceEventRule: {
                payload: [
                    {
                        path: 'control.id',
                        operator: 'eq',
                        value: 'trendlines-page-selector-select',
                    },
                ],
            },
        },
    ] as any[],
    props: {
        id: idCreator(idRoot, ['controls']),

        controls: [
            {
                id: `trendlines-page-selector-select`,
                type: 'Select',
                style: 'dark',
                name: 'currentUrl',
                value: { value: currentValue },

                classes: {
                    ...matInputHideSubscript(),
                    ...addContainerClassesNoRules([
                        '!text-white',
                        'w-[300px]',
                        'py-5',
                        'pr-10',
                        'inline-block',
                        'sm:py-0',
                        'sm:px-5',
                    ]),
                    ...multiClasses(
                        [
                            'px-2',
                            'border-solid',
                            'border-0',
                            '!border-l-2',
                            '!border-dat-blue-500',
                        ],
                        ['.mat-mdc-select-arrow-wrapper'],
                    ),
                    ...multiClasses(
                        ['!h-[40px]'],
                        [
                            '.mat-mdc-text-field-wrapper',
                            '.mat-mdc-form-field-infix',
                            '.mat-mdc-select-value',
                            '.mat-mdc-select-arrow-wrapper',
                        ],
                    ),
                    ...multiClasses(
                        ['!relative', '!px-4', '!py-2'],
                        ['.mat-mdc-select-value'],
                    ),
                },
                options: [
                    {
                        value: '/trendlines',
                        data: '/trendlines',
                        display: 'View Trends',
                    },
                    {
                        value: '/trendlines/van/demand-and-capacity',
                        data: '/trendlines/van/demand-and-capacity',
                        display: 'Van Demand & Capacity',
                    },
                    {
                        value: '/trendlines/van/national-rates',
                        data: '/trendlines/van/national-rates',
                        display: 'National Van Rates',
                    },
                    {
                        value: '/trendlines/flatbed/demand-and-capacity',
                        data: '/trendlines/flatbed/demand-and-capacity',
                        display: 'Flatbed Demand & Capacity',
                    },
                    {
                        value: '/trendlines/flatbed/national-rates',
                        data: '/trendlines/flatbed/national-rates',
                        display: 'National Flatbed Rates',
                    },
                    {
                        value: '/trendlines/reefer/demand-and-capacity',
                        data: '/trendlines/reefer/demand-and-capacity',
                        display: 'Reefer Demand & Capacity',
                    },
                    {
                        value: '/trendlines/reefer/national-rates',
                        data: '/trendlines/reefer/national-rates',
                        display: 'National Reefer Rates',
                    },
                ],
            },
        ],
    },
});
